export default {
  id: 'molten.string.StartsWith.ComparatorFilterConverter',
  type: 'string.StartsWith',
  convert: (cmp, attribute) => {
    if (cmp?.value1 == null || cmp?.value1.length === 0) {
      return null;
    }
    if (Array.isArray(cmp.value1)) {
      return {
        type: 'logical',
        operator: 'or',
        conditions: cmp.value1.map(v => {
          return {
            type: 'expression',
            value: `${v}.*`,
            field: attribute.blueprint.field,
            kind: 'regexp',
            ignoreCase: true
          };
        })
      };
    }
    return {
      type: 'expression',
      value: `${cmp.value1}.*`,
      field: attribute.blueprint.field,
      kind: 'regexp',
      ignoreCase: true
    };
  }
};